import { useCallback, useState } from "react";

const useForm = (initialValues, validationSchema, callback) => {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const validate = async (newValues) => {
    try {
      await validationSchema.validate(newValues, { abortEarly: false });
      setErrors({});
      return true;
    } catch (err) {
      const formattedErrors = err.inner.reduce((acc, error) => {
        return {
          ...acc,
          [error.path]: error.message,
        };
      }, {});
      setErrors(formattedErrors);
      return false;
    }
  };

  const handleChange = useCallback(
    (fieldName, value) => {
      setValues((old) => {
        const newValues = {
          ...old,
          [fieldName]: value,
        };
        if (hasSubmitted) {
          validate(newValues);
        }
        return newValues;
      });
    },
    [hasSubmitted]
  );

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setHasSubmitted(true);
    const isValid = await validate(values);
    if (isValid) {
      callback(values);
    }
  };

  return {
    values,
    errors,
    handleChange,
    handleFormSubmit,
    setValues,
  };
};

export default useForm;
